const URL_BASE_API = import.meta.env.VITE_API_BASE_URL;  

export {
    URL_BASE_API,
};
